import React from "react";
import { useIncomeSummaryModel } from "../incomeSummaryModel";
import { IIncomeEnum } from "../incomeSummaryService";
import { YhBox } from "@/components/YhBox";
import { Button } from "antd";
import { SearchTypeEnum, ISearchValue } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { useDictModel } from "@/views/base/dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";



export function PageHeader() {
    const {
        tabsType, setTabsType,
        searchParam,
        initPgCfg,
        updateSearchParam,
        resetSearchParam,
        loadData,
        incomeDetailLoadData
    } = useIncomeSummaryModel();
    const { getSelectedDictOne } = useDictModel(() => []);

    const action = <>
        <Button
            className={`ml-15 mr-5 ${tabsType === IIncomeEnum.INCOMEDETAILS ? "tab-buts-active" : ""}`}
            type="primary"
            shape="round"
            onClick={() => setTabsType(IIncomeEnum.INCOMEDETAILS)}
        >收入明细</Button>
        <Button
            className={`mr-5 ${tabsType === IIncomeEnum.ANNUALINCOME ? "tab-buts-active" : ""}`}
            type="primary"
            shape="round"
            onClick={() => setTabsType(IIncomeEnum.ANNUALINCOME)}
        >全年收入</Button>
        {/* <Button
            className={`mr-5 ${tabsType === IIncomeEnum.ANNUALCOST ? "tab-buts-active" : ""}`}
            type="primary"
            shape="round"
            onClick={() => setTabsType(IIncomeEnum.ANNUALCOST)}
        >全年成本</Button> */}
        <Button
            className={`mr-5 ${tabsType === IIncomeEnum.INCOMESUMMARY ? "tab-buts-active" : ""}`}
            type="primary"
            shape="round"
            onClick={() => setTabsType(IIncomeEnum.INCOMESUMMARY)}
        >收入汇总</Button>
    </>
    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: "客户名称",
            fieldName: "customerName"
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: "销售单号",
            fieldName: "documentNumber"
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "单据类型",
            fieldName: "tradeTypeCode",
            options: getSelectedDictOne(DictCodeEnmu.TRADE_TYPE).filter((item: any) => (item.value !== "trade-type.sale-order" && item.value.indexOf("sale") > -1) || item.value.indexOf("maintenance") > -1)

        },
        {
            type: SearchTypeEnum.RangePicker,
            fieldName: "",
            placeholder: ["制单开始", "制单结束"],
            rangePickerFieldName: ["createStartTime", "createEndTime"],
            format: "YYYY-MM-DD",
            span: 12,
            xxl: 6,
        },

    ]
    const searchMoreFields = [
        {
            type: SearchTypeEnum.RangePicker,
            fieldName: "",
            placeholder: ["结算开始", "结算结束"],
            rangePickerFieldName: ["settlementStartTime", "settlementEndTime"],
            format: "YYYY-MM-DD",
            span: 12,
            xxl: 6,
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "维修类型",
            fieldName: "serviceNatureCode",
            options: getSelectedDictOne(DictCodeEnmu.REPAIR_TYPE)
        }
    ]

    return (
        <YhBox style={{ marginBottom: "5px" }}>
            {tabsType === IIncomeEnum.INCOMEDETAILS && <YhPageHeader
                title="收入汇总表"
                size="small"

                triggerSearch={true}
                searchValues={searchParam as ISearchValue}
                searchFields={searchFields}
                searchMoreFields={searchMoreFields}
                onChange={updateSearchParam}
                handleSearch={(params) => { incomeDetailLoadData(initPgCfg, { ...searchParam, ...params }) }}
                handleReset={resetSearchParam}
            />}
            {action}
        </YhBox>
    );
}